import React, { useCallback } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Button } from 'components/ui';
import AddToBasketButton from 'components/AddToBasketButton';
import skuUtils from 'utils/Sku';
import skuHelpers from 'utils/skuHelpers';
import auth from 'utils/Authentication';
import ADD_BUTTON_TYPE from 'utils/Basket';
import anaConstants from 'analytics/constants';
import { HEADER_VALUE } from 'constants/authentication';
import localeUtils from 'utils/LanguageLocale';
import BiRewardButtonEN from './locales/BiRewardButton_en_US';
import BiRewardButtonFR from './locales/BiRewardButton_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(BiRewardButtonEN, BiRewardButtonFR);

const BiRewardButton = props => {
    const {
        sku, analyticsContext, isAnonymous, basket
    } = props;

    const getCtaText = useCallback(() => {
        const isAppExclusive = skuUtils.isAppExclusive(sku);
        const isBiExclusive = skuUtils.isBiExclusive(sku);
        const { calculateIsInBasketFlagOnChannel } = Sephora.configurationSettings;
        const isSkuInBasket = calculateIsInBasketFlagOnChannel ? skuHelpers.isInBasket(sku.skuId, basket) : false;

        if (isAppExclusive || (isBiExclusive && !skuHelpers.isBiQualify(sku))) {
            return `${skuUtils.getExclusiveText(sku)} ${getText('exclusive')}`;
        }

        if (!isSkuInBasket) {
            return getText('addToBasketShort');
        }

        return getText('remove');
    }, [sku, basket]);

    const signInHandler = useCallback(
        e => {
            e.stopPropagation();
            e.preventDefault();
            auth.requireAuthentication(
                null,
                null,
                {
                    context: analyticsContext,
                    nextPageContext: analyticsContext
                },
                null,
                false,
                HEADER_VALUE.USER_CLICK
            ).catch(() => { });
        },
        [analyticsContext]
    );

    return (
        <Box
            marginTop='auto'
            paddingTop={2}
        >
            {isAnonymous ? (
                <Button
                    variant='secondary'
                    size='sm'
                    onClick={signInHandler}
                >
                    {getText('signInToAccess')}
                </Button>
            ) : (
                <AddToBasketButton
                    isRewardItem
                    analyticsContext={analyticsContext || anaConstants.CONTEXT.BASKET_REWARDS}
                    variant={ADD_BUTTON_TYPE.SECONDARY}
                    isAddButton={true}
                    size='sm'
                    sku={sku}
                    isBIRBReward={true}
                    onlyUseTextProp={getCtaText()}
                    containerTitle={anaConstants.CAROUSEL_NAMES.REWARD_BAZAAR}
                />
            )}
        </Box>
    );
};

export default wrapFunctionalComponent(BiRewardButton, 'BiRewardButton');
